import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0e98ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100 container" }
const _hoisted_2 = {
  class: "modal fade",
  id: "confirmModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, null, -1 /* HOISTED */))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "車台番号を正しく入力してください")
], -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary",
    "data-bs-dismiss": "modal"
  }, " YES ")
], -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  class: "modal fade",
  id: "errorModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_12 = { class: "modal-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, null, -1 /* HOISTED */))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("車台番号を確認し"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("再度撮影してください")
  ])
], -1 /* HOISTED */))
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("車台番号")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_21 = { class: "modal-footer" }
const _hoisted_22 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "車台番号を送信してください", -1 /* HOISTED */))
const _hoisted_24 = ["src"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-primary btn-sm",
  for: "selectFile"
}, "ファイルを選択", -1 /* HOISTED */))
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-secondary btn-sm",
  for: "selectFile"
}, "ファイルを選択", -1 /* HOISTED */))
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "車台番号送信", -1 /* HOISTED */))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 3 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "車台番号送信", -1 /* HOISTED */))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "rounded-3 mt-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "車台番号", -1 /* HOISTED */))
const _hoisted_37 = { class: "col-auto d-flex justify-content-center" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "d-flex justify-content-end" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "次へ", -1 /* HOISTED */))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { class: "d-flex justify-content-end" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "次へ", -1 /* HOISTED */))
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createCommentVNode(" モーダル "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          ($setup.vinFlag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          ($setup.vinNo === '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectFileFlag = false))
                  }, " 戻る ")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", null, [
                    _hoisted_19,
                    _hoisted_20,
                    _createTextVNode(_toDisplayString($setup.vinNo), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.inputFix()))
                  }, " NO "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.nextButtonFlag = true, $setup.selectFileFlag = false))
                  }, " YES ")
                ])
              ]))
        ])
      ])
    ]),
    ($setup.ocrError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, " ファイルを選択してください "))
      : _createCommentVNode("v-if", true),
    _hoisted_23,
    _createElementVNode("img", {
      class: "image-area mb-1 mt-1",
      src: $setup.url
    }, null, 8 /* PROPS */, _hoisted_24),
    _createElementVNode("form", null, [
      (!$setup.selectFileFlag && !$setup.nextButtonFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("label", null, " " + _toDisplayString($setup.filename), 1 /* TEXT */),
            _createElementVNode("input", {
              id: "selectFile",
              type: "file",
              onChange: $setup.selectedFile
            }, null, 32 /* HYDRATE_EVENTS */)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("label", null, " " + _toDisplayString($setup.filename), 1 /* TEXT */),
            _createElementVNode("input", {
              id: "selectFile",
              type: "file",
              onChange: $setup.selectedFile
            }, null, 32 /* HYDRATE_EVENTS */)
          ])),
      ($setup.selectFileFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary mt-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.submitPicture()))
            }, _hoisted_31)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary mt-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.submitPicture()))
            }, _hoisted_34)
          ]))
    ]),
    _createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _createElementVNode("div", _hoisted_37, [
        _withDirectives(_createElementVNode("input", {
          id: "vinNo",
          type: "text",
          class: "form-control w-75 text-center",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.vinNo) = $event)),
          maxlength: "12"
        }, null, 512 /* NEED_PATCH */), [
          [
            _vModelText,
            $setup.vinNo,
            void 0,
            { trim: true }
          ]
        ])
      ])
    ]),
    ($setup.vinNo.length === 12 && $setup.nextButtonFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary mt-2",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.submitVinNo()))
            }, _hoisted_41)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary mt-2",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.submitVinNo()))
            }, _hoisted_45)
          ])
        ]))
  ]))
}